<div class="flex flex-column" style="width: 100%">
  <!-- POMEMBNO: Ne izbrisemo komentarja zaradi lazjega prevzema novejse verzije Primeng Ultima
  <span class="footer-text-left">PrimeNG ULTIMA for Angular 2</span>
  -->

  <span class="m-1 footer-container">
    <div class="flex flex-column justify-content-center">
      <div>
        <span class="far fa fa-copyright m-1"></span>
        <span> 2025 Agencija Republike Slovenije za kmetijske trge in razvoj podeželja </span>
      </div>
    </div>
  </span>
</div>
